import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

import { useNavigate } from "react-router-dom";
import { EditUserForm } from ".";
import { apiURI, authErrorRedirect } from "../common";

export function EditUser() {
  const { email } = useParams();
  const history = useNavigate();

  const [errors, setErrors] = useState({});
  const [role, setRole] = useState("");
  const [organization, setOrganization] = useState("");
  const [department, setDepartment] = useState("");
  const [organizationsList, setOrganizationsList] = useState([]);
  const [departmentsList, setDepartmentsList] = useState([]);

  const handleChangeDepartment = (event) => {
    setDepartment(event.target.value);
  };
  // Function to handle organization selection
  const handleChangeOrganization = (event) => {
    setOrganization(event.target.value);
    // Find the selected organization
    const selectedOrganization = organizationsList.find(
      (org) => org.name === event.target.value
    );
    setDepartmentsList(selectedOrganization.departments);
  };
  const handleChangeRole = (event) => {
    setRole(event.target.value);
  };
  useEffect(() => {
    axios
      .get(`${apiURI}/form/getOrganizationsList`)
      .then(async (response) => {
        setOrganizationsList(response.data);
      })
      .catch((response) => {
        console.log("error in axios form call react");
        setErrors({});
        setErrors(response.response.data);
        authErrorRedirect(response.response.data, history);
      });
    // eslint-disable-next-line no-console
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const editUser = {
      userID: data.get("username"),
      firstName: data.get("firstName"),
      lastName: data.get("lastName"),
      organization: organization,
      department: department,
      email: email,
      newEmail: data.get("email"),
      password: data.get("password"),
      password2: data.get("password2"),
      role: role,
    };

    axios
      .post(`${apiURI}/auth/editUser`, editUser)
      .then(() => {
        history(
          `/userDetails/${editUser.newEmail ? editUser.newEmail : email}`
        );
      })
      .catch((response) => {
        console.log("error in axios login call react");
        setErrors({});
        setErrors(response.response.data);
        authErrorRedirect(response.response.data, history);
      });
    // eslint-disable-next-line no-console
  };

  errors && console.log(errors);
  return (
    <div>
      <EditUserForm
        organizationsList={organizationsList}
        departmentsList={departmentsList}
        errors={errors}
        organization={organization}
        department={department}
        role={role}
        handleChangeOrganization={handleChangeOrganization}
        handleChangeDepartment={handleChangeDepartment}
        handleChangeRole={handleChangeRole}
        handleSubmit={handleSubmit}
      />
    </div>
  );
}
